import { Box, InputAdornment } from "@mui/material";
import React from "react";
import CustomTextField from "../Form/CustomTextField";
import CustomSelect2 from "../Form/CustomSelect2";
import DatePicker from "../Form/DatePicker";
import "./custom-toolbar.css";

export default function CustomToolbar({
  length,
  onLengthChange,
  search,
  onSearchChange,
  filters,
  filterList = [],
  actions,
  pageSizes = [10, 20, 30, 40, 50],
  searchPlaceholder = "Search...",
  searchAriaLabel = "Search listing",
  className = "",
}) {
  const configuredFilters = filterList.map((filter, index) => {
    const key = filter.name || `${filter.type}-${index}`;
    if (filter.type === "select") {
      const data = filter.placeholder
        ? [{ [filter.valueName || "value"]: "", [filter.labelName || "label"]: filter.placeholder }, ...(filter.data || [])]
        : filter.data || [];
      return (
        <CustomSelect2
          key={key}
          label={filter.label}
          values={filter.value ?? ""}
          data={data}
          valueName={filter.valueName}
          labelName={filter.labelName}
          disabled={filter.disabled}
          error={filter.error}
          onChange={event => filter.onChange?.(event.target.value)}
        />
      );
    }
    if (filter.type === "datetime" || filter.type === "date") {
      const name = filter.name || key;
      const setValue = updater => {
        const current = { [name]: filter.value ?? "" };
        const next = typeof updater === "function" ? updater(current) : updater;
        filter.onChange?.(next?.[name] ?? "");
      };
      return (
        <div key={key} className="custom-toolbar-date">
          <DatePicker
            title={filter.label}
            values={filter.value}
            name={name}
            setFormValues={setValue}
            error={filter.error}
            disabled={filter.disabled}
            clearIcon
          />
        </div>
      );
    }
    return null;
  }).filter(Boolean);

  return (
    <Box className={`custom-table-toolbar listing-toolbar ${className}`.trim()}>
      <Box className="custom-toolbar-length">
        <select
          className="form-select"
          aria-label="Rows per page"
          value={length}
          onChange={event => onLengthChange(Number(event.target.value))}
        >
          {pageSizes.map(size => <option key={size} value={size}>Show {size}</option>)}
        </select>
      </Box>

      <Box className="custom-toolbar-search">
        <CustomTextField
          values={search}
          placeholder={searchPlaceholder}
          onChange={event => onSearchChange(event.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start" className="auth-icon"><i className="ri-search-line" /></InputAdornment>,
            inputProps: { "aria-label": searchAriaLabel },
          }}
        />
      </Box>

      {(configuredFilters.length > 0 || filters) && (
        <Box className="custom-toolbar-filters">{configuredFilters.length > 0 ? configuredFilters : filters}</Box>
      )}
      {actions && <Box className="custom-toolbar-actions">{actions}</Box>}
    </Box>
  );
}
